import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProjectAddonsRequest } from "Api/organizations/projects/getProjectAddons.request";

import type { ProjectAddonsList } from "Api/organizations/projects/getProjectAddons.request";

export const getProjectAddons = createAsyncThunk<
  ProjectAddonsList,
  {
    organizationId: string;
    projectId: string;
  }
>(
  "app/organization/get_project_addons",
  async ({ organizationId, projectId }, { rejectWithValue }) => {
    try {
      const addons = await getProjectAddonsRequest({
        organizationId,
        projectId
      });
      return addons;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
